export default __webpack_public_path__ + "static/media/icon-trash.d03c2977.svg";